import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormMaskedTextField,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface ICollectionVoucherSetupFieldsPanel extends ITest {
	clientsDDL: any,
	accountantDDL: any,
	employeeDDL: any,
	onAccountantSelectionChangeHandler: (value: any) => void,
	onClientSelectionChangeHandler: (value: any) => void,
	transactionType: any;
	setTransactionType: (value: null) => void;
	formMethods: any
}
export const CollectionVoucherSetupFieldsPanel: FC<
	ICollectionVoucherSetupFieldsPanel
> = ({
	clientsDDL,
	accountantDDL,
	employeeDDL,
	onAccountantSelectionChangeHandler,
	onClientSelectionChangeHandler,
	transactionType,
	setTransactionType,
	formMethods,
}) => {

		// const [transactionTypeHere, setTransactionTypeHere] = useState<any>(200);

		// useEffect(() => {
		// 	if (transactionType) {
		// 		setTransactionTypeHere(transactionType)
		// 	}
		// }, [transactionType])
		// const onTransactionTypeSelectionChangeHandler = (item: any) => {
		// 	setTransactionTypeHere(item.value);
		// 	setTransactionType(item.value);
		// 	formMethods.setValue('accountantId', 'all')
		// 	formMethods.setValue('clientId', 'all')
		// 	formMethods.setValue('empoloyeeId', 'all')
		// }

		const [localTransactionType, setLocalTransactionType] = useState<any>(transactionType ?? 200);

		// Sync when parent drives a change (e.g. loading saved record)
		useEffect(() => {
			if (transactionType !== undefined && transactionType !== null) {
				setLocalTransactionType(transactionType);
			}
		}, [transactionType]);

		const handleTransactionTypeChange = (item: any) => {
			setLocalTransactionType(item.value);
			setTransactionType(item.value);
			formMethods.setValue("accountantId", "all");
			formMethods.setValue("clientId", "all");
			formMethods.setValue("employeeId", "all");
		};

		const isCompanyOrEmployee = localTransactionType === 100 || localTransactionType === 300;
		const isCustom = localTransactionType === 200;
		return (
			<>
				<EnhancedDropDownRHFWithLabel
					selectName="transactionType"
					items={[
						{ label: "Voucher for Company", value: 100 },
						{ label: "Voucher for Employee", value: 300 },
						{ label: "Custom Voucher", value: 200 },
					]}
					label="Transaction Type"
					testId="transaction-type"
					selectedItem={localTransactionType}
					onSelectionChangeHandler={handleTransactionTypeChange}
				/>

				{isCustom && (
					<RHookFormTextFieldWithLabel
						label="Client Name"
						id="clientName"
						testId="client-name"
						labelPosition={LabelPosition.Top}
					/>
				)}

				{isCompanyOrEmployee && (
					<>
						<EnhancedDropDownRHFWithLabel
							selectName="accountantId"
							items={accountantDDL ?? []}
							selectedItem="all"
							label="Accountant"
							testId="accountant-ddl"
							onSelectionChangeHandler={onAccountantSelectionChangeHandler}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName="clientId"
							items={clientsDDL ?? []}
							selectedItem="all"
							label="Client"
							testId="client-ddl"
							onSelectionChangeHandler={onClientSelectionChangeHandler}
						/>
						{localTransactionType === 300 && (
							<EnhancedDropDownRHFWithLabel
								selectName="employeeId"
								items={employeeDDL ?? []}
								selectedItem="all"
								label="Employee"
								testId="employee-ddl"
							/>
						)}
					</>
				)}

				<RHookFormTextFieldWithLabel
					label="Bank Name"
					id="bankName"
					testId="bank-name"
					labelPosition={LabelPosition.Top}
					readOnly={localTransactionType !== 200 ? true : false}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Financial Institution No."
					id="financialInstitutionNo"
					testId="financialInstitutionNo"
					placeholder="0000"
					inputMaskPattern="0000"
					readOnly={localTransactionType !== 200 ? true : false}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank Transit No."
					id="bankTransitNo"
					testId="bankTransitNo"
					placeholder="00000"
					inputMaskPattern="00000"
					readOnly={localTransactionType !== 200 ? true : false}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank Account No."
					id="bankAccountNo"
					testId="bankAccountNo"
					placeholder="000000000000000000"
					inputMaskPattern="000000000000000000"
					readOnly={localTransactionType !== 200 ? true : false}
				/>
				<RHookFormDatePicker
					name="voucherDate"
					testId="voucher-date"
					label="Voucher Date"
					labelPosition={LabelPosition.Top}
					format="M dd, yy"
				/>
			</>
		);
	};
